import { PureComponent, Fragment, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
  AvRadio,
  AvRadioGroup,
} from 'availity-reactstrap-validation';

import {
  Segment,
  Modal,
  Button,
  Icon,
  Label,
  Dropdown,
} from 'semantic-ui-react';

import moment from 'moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
  Heading,
} from 'ckeditor5';

import { map, get } from '../../../../utils/lodash';

import {
  EmptyContainer,
  CustomTable,
  SeeMore,
  SlideoutPanel,
} from '../../../../components';
import {
  getBroadcastNotifications,
  getAllOrganisationList,
  createBroadcastNotifications,
} from '../../../../store/actions';

import '../../../organization';
import { HtmlService } from '../../../../services';

class NotificationForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOnlyAdmin: false,
      organisationIds: [],
      organisationError: false,
      userType: 'allOrganisation',
      message: '',
      messageError: false,
      style: 'info',
      sendAsEmail: true,
      sendToDashboard: true,
      targetsError: false,
    };
  }

  submit() {
    this.form && this.form.submit();
  }

  async handleValidSubmit(event, values) {
    try {
      const {
        organisationIds,
        isOnlyAdmin,
        message,
        sendAsEmail,
        sendToDashboard,
      } = this.state;
      const { toggle, createBroadcastNotifications, resetPage } = this.props;
      const isMessageEmpty = !message || message === '<p>&nbsp;</p>';
      const isTargetsEmpty = !sendAsEmail && !sendToDashboard;
      if (
        (values.userType === 'selectedOrganisation' &&
          !organisationIds.length) ||
        isMessageEmpty ||
        isTargetsEmpty
      ) {
        this.setState({
          organisationError:
            values.userType === 'selectedOrganisation' &&
            !organisationIds.length,
          messageError: isMessageEmpty,
          targetsError: isTargetsEmpty,
        });
      } else {
        const formData = {
          title: values.title,
          message,
          isAllSystemUsers: values.userType === 'allUsers',
          isTestToMyself: values.userType === 'testToMyself',
          style: values.style,
          sendAsEmail,
          sendToDashboard,
        };
        if (
          values.userType === 'selectedOrganisation' ||
          values.userType === 'allOrganisation'
        ) {
          formData.isAllOrganisation = values.userType === 'allOrganisation';
          formData.organisationIds = organisationIds;
          formData.isOnlyAdmin = isOnlyAdmin;
        }

        // deliberately not resetting the form here — the admin often sends
        // several similar broadcasts in a row, so title/message/targets/etc
        // stay as they were for the next one
        await createBroadcastNotifications(formData);
        if (resetPage) resetPage();
        toggle();
      }
    } catch (error) {
      console.error(
        'Error: createBroadcastNotifications ~ handleValidSubmit',
        error
      );
    }
  }

  getOrganisationOptions() {
    const { allOrganisation } = this.props;
    return map(allOrganisation, (item, i) => ({
      key: item.id,
      value: item.id,
      text: item.name,
    }));
  }

  onlyAdminToggel = () => {
    this.setState((prevState) => ({
      isOnlyAdmin: !prevState.isOnlyAdmin,
    }));
  };

  sendAsEmailToggle = () => {
    this.setState((prevState) => ({
      sendAsEmail: !prevState.sendAsEmail,
      targetsError: false,
    }));
  };

  sendToDashboardToggle = () => {
    this.setState((prevState) => ({
      sendToDashboard: !prevState.sendToDashboard,
      targetsError: false,
    }));
  };

  async onChangeOrganisation(event, data) {
    this.setState({
      organisationIds: data.value,
      organisationError: !data.value.length,
    });
  }

  render() {
    const {
      organisationError,
      isOnlyAdmin,
      messageError,
      sendAsEmail,
      sendToDashboard,
      targetsError,
    } = this.state;
    const { t } = this.props;
    const orgOptions = this.getOrganisationOptions();

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="broadcast-form"
      >
        <AvField
          label={t('common.title')}
          className="org-inputs"
          name="title"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
            maxLength: {
              value: 100,
            },
          }}
        />

        <label>{t('admin.user_organisation.communication.message')}</label>
        <CKEditor
          editor={ClassicEditor}
          data=""
          config={{
            plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
            toolbar: [
              'heading',
              'bold',
              'italic',
              'bulletedList',
              'numberedList',
            ],
          }}
          onBlur={(event, editor) => {
            const content = editor.getData();
            this.setState({ message: content, messageError: false });
          }}
        />

        <div className="style-targets-row mt-3">
          <AvRadioGroup
            value={this.state.style}
            className="styles"
            inline
            name="style"
            required
            errorMessage={t('formulary.validation.select_style')}
          >
            <div className="radio-group-horiz">
              <AvRadio
                label={t('common.information')}
                value="info"
                onChange={() => this.setState({ style: 'info' })}
              />
              <AvRadio
                label={t('common.warning')}
                value="warning"
                onChange={() => this.setState({ style: 'warning' })}
              />
            </div>
          </AvRadioGroup>

          <div className="broadcast-targets">
            <AvCheckboxGroup name="targets">
              <AvCheckbox
                label={t('common.email')}
                value="email"
                checked={sendAsEmail}
                onChange={() => this.sendAsEmailToggle()}
              />
              <AvCheckbox
                label={t('common.dashboard')}
                value="dashboard"
                checked={sendToDashboard}
                onChange={() => this.sendToDashboardToggle()}
              />
            </AvCheckboxGroup>
          </div>
        </div>

        {targetsError ? (
          <div className="invalid-dropdown-input">
            {t('admin.user_organisation.communication.errors.select_a_target')}
          </div>
        ) : null}

        {messageError ? (
          <div className="invalid-dropdown-input">
            {t('admin.user_organisation.communication.errors.message_reqd')}
          </div>
        ) : null}

        <AvRadioGroup
          value={this.state.userType}
          inline
          name="userType"
          required
          errorMessage={t(
            'admin.user_organisation.communication.errors.select_one_option_required'
          )}
        >
          <div className="radio-group-horiz mt-3">
            <AvRadio
              label={t(
                'admin.user_organisation.communication.send_to_all_organisation'
              )}
              value="allOrganisation"
              onChange={() => this.setState({ userType: 'allOrganisation' })}
            />
            <AvRadio
              label={t(
                'admin.user_organisation.communication.send_to_selected_organisation'
              )}
              value="selectedOrganisation"
              onChange={() =>
                this.setState({ userType: 'selectedOrganisation' })
              }
            />
            <AvRadio
              label={t(
                'admin.user_organisation.communication.all_system_users'
              )}
              value="allUsers"
              onChange={() => this.setState({ userType: 'allUsers' })}
            />
            <AvRadio
              label={t('admin.user_organisation.communication.send_to_myself')}
              value="testToMyself"
              onChange={() => this.setState({ userType: 'testToMyself' })}
            />
          </div>
        </AvRadioGroup>
        {this.state.userType === 'selectedOrganisation' ? (
          <div>
            <label className="broadcast-dropdown-label">
              {t('formulary.placeholder.select_organisation')}
            </label>
            <Dropdown
              fluid
              multiple
              search
              selection
              options={orgOptions}
              onChange={(event, data) => this.onChangeOrganisation(event, data)}
              error={organisationError}
              className="broadcast-dropdown"
            />
            {organisationError ? (
              <div className="invalid-dropdown-input">
                {t(
                  'admin.user_organisation.communication.errors.select_organisation_required'
                )}
              </div>
            ) : null}
          </div>
        ) : null}

        {(this.state.userType === 'allOrganisation' ||
          this.state.userType === 'selectedOrganisation') && (
          <>
            <AvCheckboxGroup
              name="onlyAdmin"
              className="mt-4 onlyAdminCheckbox"
            >
              <AvCheckbox
                label={t(
                  'admin.user_organisation.communication.send_to_only_admins'
                )}
                checked={isOnlyAdmin}
                onChange={(e) => this.onlyAdminToggel()}
              />
            </AvCheckboxGroup>
          </>
        )}
      </AvForm>
    );
  }
}

class CreateNotification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.notificationFormRef = createRef();
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, notificationsLoading } = this.props;

    return (
      <div className="add-goal">
        <Button className="Primary-Button" onClick={() => this.toggle()}>
          <div className="add-icon-activity-add">
            <Icon name="plus circle" />
            <div className="add-text">
              {t('admin.user_organisation.communication.broadcast_message')}
            </div>
          </div>
        </Button>
        <SlideoutPanel
          open={modal}
          onClose={() => this.toggle()}
          title={t('notifications.broadcast_new_message')}
          className="broadcast-message-panel dialog-style1 dialog-width-lg"
          actions={
            <Fragment>
              <Button
                className="Primary-Button Medium"
                loading={notificationsLoading.broadcast}
                disabled={notificationsLoading.broadcast}
                onClick={() =>
                  this.notificationFormRef.current &&
                  this.notificationFormRef.current.submit()
                }
              >
                {t('actions.send')}
              </Button>
              <Button
                className="Secondary-Button Medium"
                onClick={() => this.toggle()}
              >
                {t('actions.cancel')}
              </Button>
            </Fragment>
          }
        >
          <NotificationForm
            {...this.props}
            ref={this.notificationFormRef}
            toggle={() => this.toggle()}
          />
        </SlideoutPanel>
      </div>
    );
  }
}

class ViewNotification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { records, t } = this.props;
    return (
      <Modal
        trigger={
          <label className="org-checklist-actions-warn">
            {t('actions.view')}
          </label>
        }
        size="small"
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        className="view-broadcast-message"
      >
        <Modal.Header>
          {t('admin.user_organisation.communication.view_broadcast_message')}
        </Modal.Header>
        <Modal.Content className="pre-line">
          {HtmlService.convertToInnerHtml({
            children: get(records, 'message'),
            richText: true,
            htmlConversionStyle: 'para',
            returnAs: 'html',
          })}
        </Modal.Content>
      </Modal>
    );
  }
}

const EvaluationGroup = (props) => {
  const {
    item: { organisation },
  } = props;
  return <div className="objective-eval">{organisation.name}</div>;
};

class Broadcast extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  componentDidMount() {
    const { getBroadcastNotifications, getAllOrganisationList } = this.props;
    getBroadcastNotifications();
    getAllOrganisationList();
  }

  columns() {
    const { t, i18n } = this.props;
    return [
      {
        title: t('formulary.title'),
        render: (data) => {
          return (
            <label className="notification-title">
              <div className="title">{get(data, 'title', '-')}</div>
              <div className="targets">
                {data.sendAsEmail && <span>{t('common.email')}</span>}
                {data.sendToDashboard && <span>{t('common.dashboard')}</span>}
              </div>
            </label>
          );
        },
      },
      {
        title: t('common.organisation'),
        width: 5,
        render: (data) => {
          return data?.isTestMessage ? (
            <Label color="teal" horizontal className="label-padding">
              {t('admin.user_organisation.communication.table.test_message')}
            </Label>
          ) : data?.isAllSystemUsers ? (
            <Label color="orange" horizontal className="label-padding">
              {t(
                'admin.user_organisation.communication.table.all_system_users'
              )}
            </Label>
          ) : data?.isAllOrganisation ? (
            <Label color="yellow" horizontal className="label-padding">
              {t(
                'admin.user_organisation.communication.table.all_organisations'
              )}
            </Label>
          ) : (
            <>
              {get(data, 'organisationMessages', []).length &&
              get(data, 'organisationMessages', []).length > 3 ? (
                <SeeMore
                  minCount={3}
                  dataSet={get(data, 'organisationMessages')}
                  CustomComponent={EvaluationGroup}
                />
              ) : (
                map(get(data, 'organisationMessages'), (org) => {
                  return (
                    <div className="objective-eval">
                      {org.organisation.name}
                    </div>
                  );
                })
              )}
            </>
          );
        },
      },
      {
        title: t('admin.user_organisation.communication.table.sender'),
        render: (data) => {
          return (
            <label className="org-checklist-text">
              {get(data, 'sender.firstName', '-')} {get(data, 'sender.surname')}
            </label>
          );
        },
      },
      {
        title: t('admin.user_organisation.communication.table.created_at'),
        render: (data) => {
          return (
            <label className="org-checklist-text">
              {get(data, 'createdAt')
                ? new Intl.DateTimeFormat(i18n.language, {
                    day: 'numeric', // 1
                    month: 'long', // September
                    year: 'numeric', // 2025
                    hour: '2-digit', // 09
                    minute: '2-digit', // 05
                    hour12: true, // AM/PM (always 12h format)
                  }).format(new Date(get(data, 'createdAt')))
                : '-'}
            </label>
          );
        },
      },
      {
        title: t('admin.user_organisation.communication.table.action'),
        render: (data) => {
          return (
            <div className="org-checklist-actions">
              <ViewNotification {...this.props} records={data} />
            </div>
          );
        },
      },
    ];
  }

  async broadcastPageChange(page) {
    const { getBroadcastNotifications } = this.props;
    await this.setState({ currentPage: page });
    getBroadcastNotifications(page);
  }

  render() {
    const { currentPage } = this.state;
    const { notificationsLoading, broadcastMessage, t } = this.props;
    return (
      <Segment
        className="acc-users-communication"
        loading={notificationsLoading.broadcast}
      >
        <div>
          <div className="outcome-admin-padded">
            <div className="button-outcome">
              <CreateNotification
                {...this.props}
                resetPage={() => this.resetPage()}
              />
            </div>
          </div>
        </div>
        <>
          {get(broadcastMessage, 'docs') && broadcastMessage.docs.length ? (
            <CustomTable
              header
              columns={this.columns()}
              data={broadcastMessage.docs}
              customClass="super-admin-table broadcast-notifications tbody-hover"
              pagination
              handlePaginationChange={(page) => this.broadcastPageChange(page)}
              page={currentPage}
              noOfPages={broadcastMessage.pages}
              keyExtractor={(item, index) => item.id}
            />
          ) : (
            <EmptyContainer
              msg={t(
                'admin.user_organisation.communication.no_notification_found'
              )}
            />
          )}
        </>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  const { organization, authentication, user } = state;
  return {
    user: authentication.user,
    notificationsLoading: user.notificationsLoading,
    broadcastMessage: user.broadcastMessage,
    organization: organization.organization,
    allOrganisation: organization.allOrganizations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getBroadcastNotifications,
      getAllOrganisationList,
      createBroadcastNotifications,
    },
    dispatch
  );
};

Broadcast = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Broadcast));

export { Broadcast };
